'use client';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore, type PersistedState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import configReducer from './slices/configSlice';
import localReducer from './slices/localSlice';
import homeReducer from './slices/homeSlice';
import inputReducer from './slices/inputSlice';
import audioReducer from './slices/audioSlice';
import userReducer from './slices/userSlice';
import shareReducer from './slices/shareSlice';
import jumpingReducer from './slices/jumpingSlice';
import layoutReducer from './slices/layoutSlice';
import spiderReducer from './slices/spiderSlice';
import chatListReducer from './slices/chatListSlice';
import historyReducer from './slices/historyListSlice';
import uploadReducer from './slices/uploadSlice';
import fileReducer from './slices/fileSlice';

const migrate = (state: PersistedState | undefined): Promise<PersistedState | undefined> => {
  if (state && state._persist?.version !== persistConfig.version) {
    return Promise.resolve(undefined);
  }
  return Promise.resolve(state);
};

const persistConfig = {
  key: 'minimax-chat',
  storage: storage,
  version: 4,
  timeout: 1000 * 60 * 60 * 24 * 7,
  whitelist: ['local'],
  migrate,
};

const rootReducer = combineReducers({
  config: configReducer,
  user: userReducer,
  share: shareReducer,
  audio: audioReducer,
  chat: chatListReducer,
  layout: layoutReducer,
  spider: spiderReducer,
  history: historyReducer,
  jumping: jumpingReducer,
  input: inputReducer,
  file: fileReducer,
  home: homeReducer,
  upload: uploadReducer,
  // 持久化
  local: localReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;

// 定义 AppDispatch 类型
export type AppDispatch = typeof store.dispatch;
